import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
//import { fetchPosts } from '../actions/postsActions';
//import { Post } from '../components/Post';
import {
    Progress,
    Text
} from '@mantine/core';
import { useSelector } from 'react-redux';
import { FooterSimple } from '../components/FooterSimple';
import { MobileSimpleHeader } from '../components/MobileSimpleHeader';
import { SchedulerCard } from '../components/SchedulerCard';

import pagani from '../assets/pagani.jpg';

//this needs params
const SchedulePage = () => {
    
    return (
        <>
            {/*<MobileSimpleHeader 
                avatar={pagani}
                drawSubSectMenu={false}
            />
            have a switch case for assignment of the sub menu*/}
            <SchedulerCard />
            <br/>
            <br/>

            <br/>
            <br/>
            <br/>
            <br/>
            {/*<FooterSimple />*/}
        </>
    )

}

export default SchedulePage
